<template>
  <div class="compact-supply-fields flex flex-col gap-2" data-testid="holder-optional-fields">
    <h2 class="text-[var(--c-primary)]">{{ t('holderOptional.title') }}</h2>
    <p class="text-sm text-gray-500">{{ t('holderOptional.hint') }}</p>
    <InputPrimary :model-value="name" :label="t('holderOptional.name')"
      :placeholder="t('holderOptional.namePlaceholder')" @update:model-value="emit('update:name', $event)" />
    <InputPrimary :model-value="surname" :label="t('holderOptional.surname')"
      :placeholder="t('holderOptional.surnamePlaceholder')" @update:model-value="emit('update:surname', $event)" />
    <InputPrimary :model-value="document" :label="t('holderOptional.document')"
      :placeholder="t('holderOptional.documentPlaceholder')" @update:model-value="emit('update:document', $event)" />
  </div>
</template>

<script setup>
// Nombre, apellidos y documento del titular, opcionales, en las tipologías que
// no los piden como obligatorios (todas salvo alta de suministro y cambio de
// titular). Van al mismo bloque «Datos del titular» que mantiene ADS desde el
// detalle (ADS-0171).
import { useI18n } from 'vue-i18n';
import InputPrimary from '@/components/inputs/input-primary.vue';

defineProps({
  name: { type: String, default: '' },
  surname: { type: String, default: '' },
  document: { type: String, default: '' },
});
const emit = defineEmits(['update:name', 'update:surname', 'update:document']);
const { t } = useI18n();
</script>
